import {
  useQuery,
} from '@tanstack/react-query';
import { IStaff } from '../../interfaces/User';
import { UserStoreAccessResponse } from './interfaces';
import { getStoreStaffByIdV2, getStoreStaffV2, getUserStoreAccessV2 } from '../../services/staff.service';
import { getStoreAssignableStaffV2 } from '../../services/store.service';

export const useGetStoreStaff = (enabled: boolean, storeId: string, query?: any) => useQuery<IStaff[]>({
  queryKey: ['staff', { storeId: storeId, query: query }],
  enabled: enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { storeId, query }] = queryKey
      const res = await getStoreStaffV2(storeId, query);
      if (!res?.data?.staffs) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.staffs;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetStoreAssignableStaff = (enabled: boolean, storeId: string, query?: any) => useQuery<IStaff[]>({
  queryKey: ['assignable-staff', { storeId, query }],
  enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { storeId, query }] = queryKey as [string, { storeId: string; query?: any }];
      const res = await getStoreAssignableStaffV2(storeId, query);
      if (!res?.data?.staffs) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.staffs;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetStoreStaffById = (enabled: boolean, storeId: string, staffId: string) => useQuery<IStaff>({
  queryKey: ['staff', { staffId: staffId }],
  enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { staffId }] = queryKey;
      const res = await getStoreStaffByIdV2(storeId, staffId);
      if (!res?.data) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetUserStoreAccess = (enabled: boolean, userId: string) => useQuery<UserStoreAccessResponse>({
  queryKey: ['user-store-access', { userId }],
  enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { userId }] = queryKey as any;
      const res = await getUserStoreAccessV2(userId);
      if (!res?.data) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});
